import { FaArrowLeft } from "react-icons/fa";
import BackendScreenerTable, { ColumnConfig } from "../screener/BackendScreenerTable.tsx";
import PremiumAccessPage from "../PremiumAccessPage.tsx";
import ViewModeToggle from "../common/ViewModeToggle.tsx";
import ChartGridView from "../common/ChartGridView.tsx";

import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import '../SwingScreener.css';
import { usePremium } from "../../hooks/usePremium.ts";
import useScreenerData from "../../hooks/useScreenerData.ts";
import { SCREENER_PAGE_SIZE } from "../../constants/screener.ts";


const MountainScoopScanner = () => {

    const navigate = useNavigate();
    const isPremium = usePremium();
    const [viewMode, setViewMode] = useState<'list' | 'chart'>('list');
    const { data: stocksData, loading: stocksLoading, error: stocksError,
            currentPage, totalPages, totalItems, setCurrentPage } = useScreenerData('MOUNTAIN_SCOOP', isPremium);

    // Columns for stocks tab
    const stocksColumns: ColumnConfig[] = [
        { key: 'stockName', label: 'Stock Name', visible: true },
        { key: 'symbol', label: 'Symbol', visible: true },
        { key: 'capturedPrice', label: 'Captured Price', visible: true },
        { key: 'capturedOn', label: 'Captured On', visible: true },
    ];

    // Columns for backtest/history tab with maxUpside
    const historyColumns: ColumnConfig[] = [
        { key: 'stockName', label: 'Stock Name', visible: true },
        { key: 'symbol', label: 'Symbol', visible: true },
        { key: 'capturedPrice', label: 'Captured Price', visible: true },
        { key: 'currentPrice', label: 'Current Price', visible: true },
        { key: 'maxUpside', label: 'Max Upside %', visible: true },
        { key: 'capturedOn', label: 'Captured On', visible: true },
    ];

    return (
        <>
            <div className="main-content">
                {/* Header */}
                <div className="chart-header">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        <FaArrowLeft />
                    </button>
                    <h2 className="chart-title">Mountain Scoop Scanner</h2>
                </div>

                {/* Tabs */}
                <div className="scanner-tabs">
                    <button className="scanner-tab active">
                        Stocks
                    </button>
                </div>

                {/* View Mode Toggle */}
                {isPremium && (
                    <ViewModeToggle viewMode={viewMode} onViewModeChange={setViewMode} />
                )}

                {/* Content */}
                {!isPremium ? (<PremiumAccessPage />) : (
                    viewMode === 'list' ? (
                        <BackendScreenerTable
                            screenerCode="MOUNTAIN_SCOOP"
                            pageSize={SCREENER_PAGE_SIZE}
                            columns={stocksColumns}
                            viewChartButtonEnable={false}
                            data={stocksData}
                            loading={stocksLoading}
                            error={stocksError}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            onPageChange={setCurrentPage}
                        />
                    ) : (
                        <ChartGridView
                            isActive={viewMode === 'chart'}
                            data={stocksData}
                            loading={stocksLoading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            pageSize={SCREENER_PAGE_SIZE}
                            onPageChange={setCurrentPage}
                            chartConfig={{ capturedPriceRectangle: true }}
                            screenerCode="MOUNTAIN_SCOOP"
                            smaValues={[21, 50]}
                        />
                    )
                )}
            </div>
        </>
    );
}

export default MountainScoopScanner;
